import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    light:true,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: colors.green.darken1,
        secondary: colors.lightBlue.base,
        accent: colors.cyan.base,
        error: colors.red.base,
        warning: colors.yellow.base,
        info: colors.blue.base,
        success: colors.green.base
      }
    }
  }
});
